import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  level: 1,
  numberOfItems: 0,
  itemIndex: 0,
  progressCount: 0,
  correctItemsCount: 0,
  hasSeenOnboarding: false,
};

const roundReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INIT_STANDARD_ROUND:
      return {
        ...state,
        level: payload,
        itemIndex: 0,
        progressCount: 0,
        correctItemsCount: 0,
      };
    case REDUX_ACTIONS.INCREMENT_PROGRESS_COUNT:
      return {
        ...state,
        progressCount: state.progressCount + 1,
      };
    case REDUX_ACTIONS.INCREMENT_CORRECT_COUNT:
      return {
        ...state,
        correctItemsCount: state.correctItemsCount + 1,
      };
    case REDUX_ACTIONS.SET_LEVEL_ITEMS_COUNT:
      return {
        ...state,
        numberOfItems: payload,
      };

    case REDUX_ACTIONS.INCREMENT_ITEM_INDEX:
      return {
        ...state,
        itemIndex: state.itemIndex + 1,
      };

    case REDUX_ACTIONS.SET_HAS_SEEN_ONBOARDING:
      return {
        ...state,
        hasSeenOnboarding: payload,
      };

    default:
      return state;
  }
};

export default roundReducer;
